// extracted by mini-css-extract-plugin
export default {"actions":"view_actions__SsudQ"};